import React, { useContext, useEffect, useState } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import LimitedBackdrop from '../../components/UI/LimitedBackdrop';
import { separations } from '../../constants/StyleConstants';
import LogisticsAPI from '../../services/LogisticsAPI';
import { LoginContext } from '../../contexts/LoginContext';
import { AppContext } from '../../contexts/AppContext';
import { parseCLDR26 } from '../../utils/GridUtils';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    rowGap: '.4em',
  },
  serviceSheetsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    width: '100%',
    marginBottom: '.5em',
    padding: '0 2em 0 .7em',
  },
  serviceSheets: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    backgroundColor: 'rgba(0,0,0,.2)',
    padding: '.3em .8em .3em .8em',
    borderRadius: '4px',
    border: '1px solid rgba(0,0,0,.2)',
  },
}));

const LogisticsConfirmationModal = ({ open, setOpen, selectedRows, setSelectedRows, reloadGrid }) => {
  const classes = useStyles();
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [groupedData, setGroupedData] = useState([]);
  const { showError, showSuccess } = useContext(AppContext);
  const { userInfo } = useContext(LoginContext);

  useEffect(() => {
    if (open) {
      const groupedServiceSheets = selectedRows.reduce((sum, current) => {
        sum[current.serviceSheet] = current.netAmmount + (sum[current.serviceSheet] || 0);
        return sum;
      }, {});

      setGroupedData(groupedServiceSheets);
    }
  }, [open]);

  const confirmInvoices = () => {
    setOpenBackDrop(true);

    const request = {
      references: selectedRows.map(r => r.reference),
      cuit: userInfo.userName,
      invoiced: true,
    };

    return LogisticsAPI.confirmInvoices(request)
      .then(res => {
        showSuccess('Los remitos a facturar se confirmaron con éxito');
        setSelectedRows([]);
        reloadGrid();
      })
      .catch(error => {
        const errorMsg = 'Error al confirmar los remitos a facturar';
        showError(errorMsg, error);
        throw new Error(errorMsg);
      })
      .finally(() => {
        setOpen(false);
        setTimeout(() => setOpenBackDrop(false), 250);
      });
  };

  return (
    <DialogAcerBrag open={open} setOpen={setOpen} title="Resumen de remitos a facturar" action={confirmInvoices}>
      <LimitedBackdrop open={openBackDrop}>
        <CircularProgress color="primary" />
      </LimitedBackdrop>
      <div className={classes.root}>
        <div className={classes.serviceSheetsHeader}>
          <div>Hojas de servicio</div>
          <div>Valor</div>
        </div>
        {Object.entries(groupedData).map(([serviceSheet, sumAmmount]) => (
          <div className={classes.serviceSheets}>
            <div>{serviceSheet}</div>
            <div>ARS {parseCLDR26(sumAmmount)}</div>
          </div>
        ))}
      </div>
    </DialogAcerBrag>
  );
};
export default LogisticsConfirmationModal;
